export default __webpack_public_path__ + "static/media/resume.48ea779b.pdf";